import { closeChat, openChat } from '../../../react/features/chat/actions.web';
import { hideToolbox, setToolboxVisible } from '../../../react/features/toolbox/actions';
import {
    TUTORIAL_NAME
} from '../../modules/Tutorial/constants';
import WildixUIEvents from '../../service/WildixUIEvents';
import TutorialDialog from '../../wizyconf/keyboard/controls/TutorialDialog';

import { FOCUS_CONTROL_TIMEOUT } from './constants';
import ChatIGallery from './controls/ChatIGallery';
import FooterItems from './controls/FooterItems';
import LocalVideo from './controls/LocalVideo';
import ParticipantItems from './controls/ParticipantItems';
import PopupAlone from './controls/PopupAlone';
import RejoinDialog from './controls/RejoinDialog';
import SettingsDialogItems from './controls/SettingsDialogItems';
import ToggleFilmstrip from './controls/ToggleFilmstrip';


export default class FocusControll {

    get isRemoteParticipantsExist() {
        return APP.store.getState()['features/filmstrip'].remoteParticipants?.length;
    }

    get isVisitorMode() {
        return APP.store.getState()['features/visitors'].iAmVisitor;
    }

    get tileViewEnabled() {
        return APP.store.getState()['features/video-layout'].tileViewEnabled;
    }

    get isDialogOpened() {
        return Boolean(APP.store.getState()['features/base/dialog']?.component);
    }

    get isTutorialVisible() {
        return APP.store.getState()['wildix/features/tutorial']?.visible;
    }

    constructor() {
        this._focusedControl = null;

        this.footerItems = new FooterItems();
        this.participantItems = new ParticipantItems();
        this.settingsDialogItems = new SettingsDialogItems();
        this.chatItems = new ChatIGallery();
        this.localVideo = new LocalVideo();
        this.toggleFilmstrip = new ToggleFilmstrip();
        this.rejoinDialog = new RejoinDialog();
        this.popupAlone = new PopupAlone();
        this.tutorialDialog = new TutorialDialog();

        this.roadmap = {
            localVideo: {
                up: {
                    callback: () => {
                        this._setFocusControll(this.footerItems, 0);
                    }
                },
                down: {
                    callback: () => {
                        if (this.isRemoteParticipantsExist) {
                            this._setFocusControll(this.participantItems, 0);
                        } else {
                            this._setFocusControll(this.footerItems, 0);
                        }
                    }
                },
                next: {
                    callback: () => {
                        this._setFocusControll(this.footerItems, 0);
                    }
                },
                prev: {
                    callback: () => {
                        this._setFocusControll(this.toggleFilmstrip);
                    }
                }
            },
            participantItems: {
                up: {
                    callback: () => {
                        if (this.isVisitorMode) {
                            this._setFocusControll(this.footerItems);
                        } else {
                            this._setFocusControll(this.localVideo);
                        }
                    }
                },
                down: {
                    callback: () => {
                        this._setFocusControll(this.footerItems);
                    }
                },
                next: {
                    callback: () => {
                        this._setFocusControll(this.footerItems, 0);
                    }
                },
                prev: {
                    callback: () => {
                        this._setFocusControll(this.toggleFilmstrip);
                    }
                }
            },
            toggleFilmstrip: {
                up: {
                    callback: () => {
                        if (this.tileViewEnabled) {
                            this._setFocusControll(this.footerItems);
                        } else if (this.isRemoteParticipantsExist || this.isVisitorMode) {
                            this._setFocusControll(this.participantItems, this.lengthParticipant());
                        } else {
                            this._setFocusControll(this.localVideo);
                        }
                    }
                },
                down: {
                    callback: () => {
                        this._setFocusControll(this.footerItems);
                    }
                },
                next: {
                    callback: () => {
                        if (!this.tileViewEnabled) {
                            if (!this.isRemoteParticipantsExist && !this.isVisitorMode) {
                                this._setFocusControll(this.localVideo);
                            } else {
                                this._setFocusControll(this.participantItems, this.lengthParticipant());
                            }
                        } else {
                            this._setFocusControll(this.footerItems, 0);
                        }
                    }
                },
                prev: {
                    callback: () => {
                        this._setFocusControll(this.footerItems);
                    }
                }
            },
            footerItems: {
                up: {
                    callback: () => {
                        if (!this.tileViewEnabled) {
                            if (!this.isRemoteParticipantsExist && !this.isVisitorMode) {
                                this._setFocusControll(this.localVideo);
                            } else {
                                this._setFocusControll(this.participantItems, this.lengthParticipant());
                            }
                        } else {
                            this._setFocusControll(this.toggleFilmstrip);
                        }
                    }
                },
                down: {
                    callback: () => {
                        if (!this.tileViewEnabled && !this.isVisitorMode) {
                            this._setFocusControll(this.localVideo);
                        }
                    }
                },
                next: {
                    callback: () => {
                        if (this._focusedControl?.isPossibleNext()) {
                            this._focusedControl.next();
                        } else {
                            this._setFocusControll(this.toggleFilmstrip);
                        }
                    }
                },
                prev: {
                    callback: () => {
                        if (this._focusedControl?.isPossiblePrev()) {
                            this._focusedControl.prev();
                        } else if (!this.tileViewEnabled) {
                            if (!this.isRemoteParticipantsExist) {
                                this._setFocusControll(this.localVideo);
                            } else {
                                this._setFocusControll(this.participantItems, this.lengthParticipant());
                            }
                        } else {
                            this._setFocusControll(this.toggleFilmstrip);
                        }
                    }
                }
            }
        };

        APP.wildix.eventEmitter.on(WildixUIEvents.DIALOG_OPENED, this._handleDialogOpened.bind(this));
        APP.wildix.eventEmitter.on(WildixUIEvents.DIALOG_CLOSED, this._handleDialogClosed.bind(this));
        APP.wildix.eventEmitter.on(WildixUIEvents.UPDATE_LOCAL_VIDEO, () => {
            console.warn('UPDATE_LOCAL_VIDEO');
            this.localVideo.collectElements();
            this.participantItems.updateContainer();
        });
        APP.wildix.eventEmitter.on(WildixUIEvents.UPDATE_TOGGLE_BUTTON, state => {
            console.warn('UPDATE_TOGGLE_BUTTON');
            this.toggleFilmstrip.collectElements();
            if (typeof state !== 'undefined') {
                this._setFocusControll(this.toggleFilmstrip);
            }
        });
    }

    reinitialize() {
        if (this.participantItems) {
            this.participantItems.init();
        }
    }

    lengthParticipant() {
        const { remoteParticipants } = APP.store.getState()['features/filmstrip'];

        if (remoteParticipants) {
            return remoteParticipants.length - 1;
        }

        return 0;
    }

    _handleDialogOpened({ type }) {
        switch (type) {
        case 'settings':
            this._onOpenSettingsDialog();
            break;
        case 'rejoin':
            this._onOpenRejoinDialog();
            break;
        case 'chat_gallery':
            this._onOpenChatDialog();
            break;
        case 'popup-alone':
            this._onOpenAloneDialog();
            break;
        case TUTORIAL_NAME:
            this._onOpenTutorialDialog();
            break;
        default:
            break;
        }
    }


    _handleDialogClosed({ type }) {
        switch (type) {
        case 'settings':
            this._onCloseSettingsDialog();
            break;
        case 'rejoin':
            this._onCloseDialInNumbers();
            break;
        case 'chat_gallery':
            this._onCloseChatDialog();
            break;
        case 'popup-alone':
            this._onCloseAloneDialog();
            break;
        case TUTORIAL_NAME:
            this._onCloseTutorialDialog();
            break;
        default:
            break;
        }
    }

    _onOpenSettingsDialog() {
        this.settingsDialogItems.init();
        this._setFocusControll(this.settingsDialogItems);
    }

    _onOpenChatDialog() {
        this.chatItems.init();
        this._setFocusControll(this.chatItems);
    }

    _onOpenRejoinDialog() {
        setTimeout(() => {
            this.rejoinDialog.init();
            this._setFocusControll(this.rejoinDialog);
        }, FOCUS_CONTROL_TIMEOUT);
    }

    _onOpenAloneDialog() {
        setTimeout(() => {
            this.popupAlone.init();
            this._setFocusControll(this.popupAlone);
        }, FOCUS_CONTROL_TIMEOUT);
    }

    _onOpenTutorialDialog() {
        setTimeout(() => {
            this.tutorialDialog.init();
            this._setFocusControll(this.tutorialDialog);
        }, FOCUS_CONTROL_TIMEOUT);
    }

    _onCloseSettingsDialog() {
        this.settingsDialogItems.destroy();
        this._setFocusControll(null);
    }

    _onCloseDialInNumbers() {
        this._setFocusControll(null);
    }

    _onCloseChatDialog() {
        this.chatItems.destroy();
    }

    _onCloseAloneDialog() {
        this.popupAlone.destroy();
        this._setFocusControll(null);
    }

    _onCloseTutorialDialog() {
        this.tutorialDialog.destroy();
        this._setFocusControll(null);
    }

    closeAll() {
        this._setAlwaysVisibleToolbar(false);
        this._setFocusControll(null);
        this._toggleChat(false);
        this._hideToolbox(false);
    }

    _setAlwaysVisibleToolbar(visible) {
        APP.store.dispatch(setToolboxVisible(visible));
    }

    _toggleChat(val) {
        if (val) {
            APP.store.dispatch(openChat());
        } else {
            APP.store.dispatch(closeChat());
        }
    }

    _hideToolbox() {
        APP.store.dispatch(hideToolbox());
    }

    isCanFocusFooterInTileView() {
        return !this.isDialogOpened && !this.isTutorialVisible && this.tileViewEnabled;
    }

    _upDownAvailable(direction) {
        const arr = [ this.settingsDialogItems, this.rejoinDialog ];

        if (this.isCanFocusFooterInTileView() || arr.includes(this._focusedControl)) {
            this._setFocusControll(this.footerItems);

            return false;
        }


        if (direction === 'up') {
            return this.isFocusControlAvailable(0);
        } else if (direction === 'down') {
            return this.isFocusControlAvailable(this.lengthParticipant());
        }

        return true;
    }

    isFocusControlAvailable(index) {
        if (!this._focusedControl) {
            if (!this.tileViewEnabled) {
                if (this.isRemoteParticipantsExist) {
                    this._setFocusControll(this.participantItems, index);

                    return false;
                }
                this._setFocusControll(this.toggleFilmstrip, index);
            } else {
                this._setFocusControll(this.footerItems);
            }

            return false;
        }

        return true;
    }

    up() {
        const available = this._upDownAvailable('up');

        if (!available) {
            return;
        }

        const obj = this.roadmap[this._focusedControl.namespace];

        if (this._focusedControl?.isPossibleUp()) {
            this._focusedControl.up();
        } else if (obj) {
            obj.up.callback();
        }
    }

    down() {
        const available = this._upDownAvailable('down');

        if (!available) {
            return;
        }

        const obj = this.roadmap[this._focusedControl.namespace];

        if (this._focusedControl?.isPossibleDown()) {
            this._focusedControl.down();
        } else if (obj) {
            obj.down.callback();
        }
    }

    next() {
        if (this.isMainWindowControl(this._focusedControl)) {
            const { next } = this.roadmap[this._focusedControl.namespace];

            if (next && next.callback) {
                next.callback();

                return;
            }
        }

        if (!this._focusedControl) {
            this._setFocusControll(this.footerItems);
        } else {
            this._focusedControl?.next();
        }
    }

    prev() {
        if (this.isMainWindowControl(this._focusedControl)) {
            const { prev } = this.roadmap[this._focusedControl.namespace];

            if (prev && prev.callback) {
                prev.callback();

                return;
            }
        }

        if (!this._focusedControl) {
            this._setFocusControll(this.footerItems);
        } else {
            this._focusedControl?.prev();
        }
    }

    enter() {
        if (!this._focusedControl) {
            this._setFocusControll(this.footerItems);
        } else {
            this._focusedControl?.enter();
        }
    }

    _setFocusControll(control, focusIndex) {
        if (this._focusedControl && this._focusedControl !== control) {
            this._focusedControl.unfocus();
        }
        if (control) {
            control.focus(focusIndex);
        }

        if (this._focusedControl !== control) {
            this._setAlwaysVisibleToolbar(this.isMainWindowControl(control));
        }

        this._focusedControl = control;
    }

    unfocus() {
        this._setFocusControll(null);
    }

    isMainWindowControl(control) {
        return control === this.participantItems
            || control === this.footerItems
            || control === this.localVideo
            || control === this.toggleFilmstrip;
    }

    isMainWindowControllFocused() {
        return this.isMainWindowControl(this._focusedControl);
    }

}

